import React from "react";
import "./heat.css";

interface HeatProps {
  title: string;
  leftText: string;
  rightText: string;
  leftColor: string;
  rightColor: string;
  middleColor?: string;
  additionalColor?: string;
}

const Heat: React.FC<HeatProps> = ({
  title,
  leftText,
  rightText,
  leftColor,
  rightColor,
  middleColor,
  additionalColor,
}) => {
  const gradient =
    middleColor && additionalColor
      ? `linear-gradient(to right, ${leftColor} 0%, ${middleColor} 36%, ${additionalColor} 71%, ${rightColor} 100%)`
      : middleColor
      ? `linear-gradient(to right, ${leftColor}, ${middleColor}, ${rightColor})`
      : `linear-gradient(to right, ${leftColor}, ${rightColor})`;

  return (
    <div className="heat-container">
      <div className="heat-title">{title}</div>
      <div className="heat-meter">
        <div
          className="heat-gradient"
          style={{
            background: gradient,
          }}
        ></div>
        <div className="heat-labels">
          <span className="heat-label-left">{leftText}</span>
          <span className="heat-label-right">{rightText}</span>
        </div>
      </div>
    </div>
  );
};

export default Heat;
